/*******************************************
*  Mixin to generate typographic pairings of heading and paragraph: h2-p, h3-p, etc, etc.
*******************************************/
/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-button.get-names.ts 
*/
:host {
  box-sizing: border-box;
  display: inline-block;
}
:host * {
  box-sizing: border-box;
}

:host([full-width=true]), :host([full-width]),
:host([full-width-tablet=true]), :host([full-width-tablet]),
:host([full-width-mobile=true]), :host([full-width-mobile]) {
  width: 100%;
}

@media only screen and (min-width: 1025px) {
  :host([full-width-tablet=true]), :host([full-width-tablet]) {
    width: unset;
  }
}

@media only screen and (min-width: 595px) {
  :host([full-width-mobile=true]), :host([full-width-mobile]) {
    width: unset;
  }
}

:host([full-width=false]) {
  width: unset;
}

:host([full-width-tablet=false]) {
  width: 100%;
}
@media only screen and (min-width: 595px) {
  :host([full-width-tablet=false]) {
    width: unset;
  }
}
@media only screen and (min-width: 1025px) {
  :host([full-width-tablet=false]) {
    width: 100%;
  }
}

:host([full-width-mobile=false]) {
  width: unset;
}
@media only screen and (min-width: 595px) {
  :host([full-width-mobile=false]) {
    width: 100%;
  }
}

@keyframes fade-in-loader {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes highlight {
  0% {
    left: -200%;
    opacity: 0;
  }
  25% {
    opacity: 0.8;
  }
  50% {
    left: 200%;
    opacity: 0;
  }
  100% {
    left: 200%;
    opacity: 0;
  }
}
.ace-button {
  font-feature-settings: "liga" on;
  -moz-font-feature-settings: "liga" on;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: var(--ace-type-font-size-text-regular);
  letter-spacing: var(--ace-type-letter-spacing-text-regular);
  line-height: var(--ace-type-line-height-text-regular);
  font-family: var(--ace-type-font-family-interactive);
  font-weight: var(--ace-type-font-weight-interactive);
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  align-items: center;
  border-radius: var(--ace-semantic-buttons-general-button-radius);
  cursor: pointer;
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
  height: 2.75rem;
  min-width: 2.75rem;
  justify-content: center;
  padding: 0 var(--ace-primitive-spacing-normal);
  position: relative;
  text-overflow: ellipsis;
  transition: background-color linear 100ms, border linear 100ms;
  white-space: nowrap;
  width: fit-content;
}
.ace-button__content__wrapper {
  align-items: center;
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
  justify-content: center;
  opacity: 1;
}
.ace-button__content__wrapper--loading {
  opacity: 0;
}
.ace-button__content ace-loader {
  display: flex;
  margin: 0 auto;
  left: calc(50% - 0.75rem);
  position: absolute;
  animation: fade-in-loader ease-in-out 500ms;
  top: 50%;
  transform: translateY(-50%);
}
.ace-button:hover {
  text-decoration: none;
}
.ace-button:active {
  transform: scale(0.95);
}
.ace-button svg,
.ace-button span > svg {
  fill: var(--ace-color-text-neutral--interactive-inverted);
}
.ace-button:focus-visible {
  outline: 0.125rem solid var(--ace-color-borders--focus);
  outline-offset: 0.125rem;
  z-index: 2;
}
.ace-button.ace-button__full-height {
  min-height: 100% !important;
}
.ace-button.ace-button__full-width {
  width: 100%;
}
.ace-button.ace-button__full-width-mobile {
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-button.ace-button__full-width-mobile {
    width: fit-content;
  }
}
.ace-button.ace-button__full-width-tablet {
  width: 100%;
}
@media only screen and (min-width: 1025px) {
  .ace-button.ace-button__full-width-tablet {
    width: fit-content;
  }
}
.ace-button.ace-button__type-primary {
  background-color: var(--ace-color-brand-primary--100);
  border: var(--ace-semantic-foundation-border-interactive) var(--ace-color-brand-primary--100);
  color: var(--ace-color-text-neutral--interactive-uni-light);
  text-decoration: none;
}
.ace-button.ace-button__type-primary svg,
.ace-button.ace-button__type-primary span > svg {
  fill: var(--ace-color-text-neutral--interactive-uni-light);
}
.ace-button.ace-button__type-primary:hover:not([aria-disabled=true]) {
  background-color: var(--ace-color-brand-primary--200);
  border: var(--ace-semantic-foundation-border-interactive) var(--ace-color-brand-primary--200);
}
.ace-button.ace-button__type-primary[aria-disabled=true] {
  background-color: var(--ace-color-surface-solid--300);
}
.ace-button.ace-button__type-secondary {
  background-color: var(--ace-color-brand-secondary--100);
  border: var(--ace-semantic-foundation-border-interactive) var(--ace-color-borders--200);
  color: var(--ace-color-text-neutral--interactive);
}
.ace-button.ace-button__type-secondary:hover:not([aria-disabled=true]) {
  background-color: var(--ace-color-brand-secondary--200);
  border: var(--ace-semantic-foundation-border-interactive) var(--ace-color-borders--300);
  text-decoration: none;
}
.ace-button.ace-button__type-secondary[aria-disabled=true] {
  background-color: var(--ace-color-surface-solid--300);
}
.ace-button.ace-button__type-tertiary {
  background-color: var(--ace-color-brand-tertiary--100);
  border: var(--ace-semantic-foundation-border-interactive) var(--ace-color-borders--200);
  color: var(--ace-color-text-neutral--interactive);
}
.ace-button.ace-button__type-tertiary:hover:not([aria-disabled=true]) {
  background-color: var(--ace-color-brand-secondary--200);
  text-decoration: none;
}
.ace-button.ace-button__type-tertiary[aria-disabled=true] {
  background-color: transparent;
  border-color: var(--ace-color-borders--100);
}
.ace-button.ace-button__type-hidden {
  background-color: transparent;
  border: unset;
  border: var(--ace-semantic-foundation-border-interactive) transparent;
  color: var(--ace-color-text-neutral--interactive);
}
.ace-button.ace-button__type-hidden:hover:not([aria-disabled=true]) {
  background-color: var(--ace-color-brand-secondary--200);
  border: var(--ace-semantic-foundation-border-interactive) transparent;
}
.ace-button.ace-button__type-hidden-inverted {
  background-color: transparent;
  border: unset;
  border: var(--ace-semantic-foundation-border-interactive) transparent;
  color: var(--ace-semantic-buttons-general-button-hidden-inverted-color);
}
.ace-button.ace-button__type-hidden-inverted:hover:not([aria-disabled=true]) {
  background-color: var(--ace-color-brand-secondary--200);
  border: var(--ace-semantic-foundation-border-interactive) transparent;
}
.ace-button.ace-button__type-hidden-dark {
  background-color: transparent;
  border: unset;
  border: var(--ace-semantic-foundation-border-interactive) transparent;
  color: var(--ace-color-text-neutral--interactive-uni-light);
}
.ace-button.ace-button__type-hidden-dark:hover:not([aria-disabled=true]) {
  background-color: var(--ace-color-brand-secondary--200);
  border: var(--ace-semantic-foundation-border-interactive) transparent;
}
.ace-button.ace-button__type-secondary-dark {
  background-color: var(--ace-semantic-buttons-general-button-secondary-dark-background-color);
  border: var(--ace-semantic-foundation-border-interactive) var(--ace-semantic-buttons-general-button-secondary-tertiary-dark-border-color);
  color: var(--ace-color-text-neutral--interactive-uni-light);
}
.ace-button.ace-button__type-secondary-dark:hover:not([aria-disabled=true]) {
  background-color: var(--ace-semantic-buttons-general-button-secondary-dark-hover-background-color);
  border: var(--ace-semantic-foundation-border-interactive) var(--ace-semantic-buttons-general-button-secondary-tertiary-dark-hover-border-color);
  text-decoration: none;
}
.ace-button.ace-button__type-secondary-dark[aria-disabled=true] {
  background-color: var(--ace-semantic-buttons-general-button-secondary-dark-disabled-background-color);
}
.ace-button.ace-button__type-tertiary-dark {
  background-color: var(--ace-semantic-buttons-general-button-tertiary-dark-background-color);
  border: var(--ace-semantic-foundation-border-interactive) var(--ace-semantic-buttons-general-button-secondary-tertiary-dark-border-color);
  color: var(--ace-color-text-neutral--interactive-uni-light);
}
.ace-button.ace-button__type-tertiary-dark:hover:not([aria-disabled=true]) {
  background-color: var(--ace-semantic-buttons-general-button-tertiary-dark-hover-background-color);
  text-decoration: none;
}
.ace-button.ace-button__type-tertiary-dark[aria-disabled=true] {
  background-color: transparent;
  border-color: var(--ace-color-borders--100);
}
.ace-button.ace-button__size-extra-small {
  font-size: var(--ace-type-font-size-text-x-small);
  letter-spacing: var(--ace-type-letter-spacing-text-x-small);
  line-height: var(--ace-type-line-height-text-x-small);
  font-family: var(--ace-type-font-family-interactive);
  font-weight: var(--ace-type-font-weight-interactive);
  text-decoration: none;
  border-radius: var(--ace-primitive-radius-full);
  height: 2rem;
  min-width: 2rem;
  gap: var(--ace-primitive-spacing-xx-tight);
  padding: 0 var(--ace-primitive-spacing-tight);
}
.ace-button.ace-button__size-extra-small ace-loader {
  left: calc(50% - 0.625rem);
}
.ace-button.ace-button__size-small {
  font-size: var(--ace-type-font-size-text-small);
  letter-spacing: var(--ace-type-letter-spacing-text-small);
  line-height: var(--ace-type-line-height-text-small);
  font-family: var(--ace-type-font-family-interactive);
  font-weight: var(--ace-type-font-weight-interactive);
  text-decoration: none;
  border-radius: var(--ace-primitive-radius-full);
  height: 2.5rem;
  min-width: 2.5rem;
}
.ace-button.ace-button__size-large {
  font-size: var(--ace-type-font-size-text-large);
  letter-spacing: var(--ace-type-letter-spacing-text-large);
  line-height: var(--ace-type-line-height-text-large);
  font-family: var(--ace-type-font-family-interactive);
  font-weight: var(--ace-type-font-weight-interactive);
  text-decoration: none;
  height: 3rem;
  min-width: 3rem;
  padding: 0 var(--ace-primitive-spacing-x-loose);
}
.ace-button.ace-button__circular {
  border-radius: var(--ace-primitive-radius-full);
  padding: unset;
}
.ace-button.ace-button__circular ace-loader {
  left: unset;
}
.ace-button.ace-button__highlight:not(.ace-button__disable-animations) {
  overflow: hidden;
}
.ace-button.ace-button__highlight:not(.ace-button__disable-animations):before {
  animation-delay: var(--ace-button-highlight-animation-delay, 0ms);
  animation-duration: var(--ace-button-highlight-animation-duration, 6s);
  animation-iteration-count: var(--ace-button-highlight-animation-iteration-count, infinite);
  animation-name: highlight;
  background: var(--ace-button-highlight-background, rgba(242, 242, 242, 0.3803921569));
  box-shadow: 0 0 50px #d6d6d6, inset 0 0 50px #ffffff;
  clip-path: polygon(200px 0, 100% 0, 100% 100%, 0% 100%);
  content: "";
  height: 400%;
  position: absolute;
  top: -100%;
  width: 400%;
}
.ace-button[aria-disabled=true] {
  border: var(--ace-semantic-foundation-border-interactive) transparent;
  color: var(--ace-color-text-neutral--disabled);
  cursor: auto;
  pointer-events: none;
}
.ace-button[aria-disabled=true] svg,
.ace-button[aria-disabled=true] span > svg {
  fill: var(--ace-color-text-neutral--disabled);
}